export const PRODUCTION_TIME_IN_DAYS = 5

export function getProductionTimeDigits(days = PRODUCTION_TIME_IN_DAYS) {
  const str = String(days)
  return str.length === 1 ? `0${str}` : str
}
